import { GenericTableDataFileDto, GenericFileDownloadDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import axiosServices from 'utils/axios';

export const downloadApiFile = async (data: GenericTableDataFileDto): Promise<GenericFileDownloadDto> => {
    try {
        const res = await axiosServices.get(
            `${InsideFifaBackOfficeEndpoints.GenericTables.DataFile}/${data.azureBlobPath}`,
            {
                responseType: 'blob',
            },
        );
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);

        return { file: blob, url, status: res.status };
    } catch (error) {
        throw new Error('Failed to download file');
    }
};
